export default __webpack_public_path__ + "static/media/chat_bot.872cb0d2.svg";